import { TFunction } from 'i18next';
import { filterUndefinedRows } from 'src/js/pages/statistic/statistic-mapper';
import { StatisticSectionViewModel } from 'src/js/pages/statistic/statistic-view-model';
import { toTitleCase } from 'src/js/util/global-util';
import { formatUptime } from '../stream/stream-helper';

import { ScteViewModel, scteStateToName } from './scte-models';

export const mapScteToStatistics = (scte: ScteViewModel, t: TFunction): StatisticSectionViewModel[] => {
  const stats = [
    {
      title: t('statistics.header.statistics'),
      rows: [
        {
          name: t('general.status'),
          value: toTitleCase(scteStateToName(scte.state, t), false),
        },
        {
          name: t('scte.statistics.rxBytes'),
          value: scte.stats.rxBytes,
        },
        {
          name: t('scte.statistics.rxOKMessages'),
          value: scte.stats.rxOKMessages,
        },
        {
          name: t('scte.statistics.rxCorruptMessages'),
          value: scte.stats.rxCorruptMessages,
        },
        {
          name: t('scte.statistics.lastStce104Msg'),
          value: scte.stats.lastStce104Msg,
        },
        {
          name: t('scte.statistics.lastScte104ErrorCode'),
          value: scte.stats.lastScte104ErrorCode,
        },
        {
          name: t('scte.statistics.lastScte104Error'),
          value: scte.stats.lastScte104Error,
        },
        {
          name: t('scte.statistics.lastErrorOpId'),
          value: scte.stats.lastErrorOpId,
        },
        {
          name: t('scte.statistics.lastLeapSeconds'),
          value: scte.stats.lastLeapSeconds,
        },
        {
          name: t('statistics.stream.rows.lastReset'),
          value: formatUptime(scte.stats.lastReset),
        },
      ],
    },
  ];

  return filterUndefinedRows(stats);
};
